<template>
  <div class="hello">
    <section class="main_section" v-bind:class="{ 'pic--1': true }"></section>

    <section class="text-xs-center mt-5">
      <img src="~../assets/events/special_event2019/pic_coupon.jpg" width="80%" />
    </section>

    <section class="content">
      <v-row class="text-xs-left">
        <v-col md8 offset-md2 xs12 pa-3>
          <strong>活動期間</strong><p>2019/02/12 - 2019/02/17</p>
          <strong>使用方式</strong>
          <ol class="ml-5">
            <li>消費滿1500元，於結帳前出示此折價卷畫面即可享有100元折扣優惠</li>
          </ol>

          <strong>注意事項</strong>
          <ol class="ml-5">
            <li>單筆消費限用一次。</li>
            <li>此抵用卷限2019台北國際書展LiveABC攤位(B1225)使用。</li>
            <li>請於結帳前出示折價卷給收銀人員，結帳後恕無法補登。</li>
            <li>LiveABC保留活動修改之權利。</li>
          </ol>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
export default {

  name: 'Event',

  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  section {
    position: relative;
    text-align: center;
    color: #fff;
  }

  .main_section {
    height: 50vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 0%;

    &.pic--1 {
      background-image: url('~../assets/events/special_event2019/pic_main_banner.jpg');
    }
  }

  .menu-nav {
    text-align: center;
    font-size: 1.3em;
    background-color: #fff;
    color: #000;
    padding: 1.5em;

    .active {
      color: #ccc;
    }
  }

  .content {
    background-color: #e9e8f0;
    color: #000;
    padding: 3em 5em 5em 5em;
    text-align: left;
    font-size: 1.2em;
    line-height: 250%;
    letter-spacing: 3px;

    @media screen and (max-width: 768px) {
      font-size: 1em;
      line-height: 200%;
      letter-spacing: normal;
      padding: 1em 2em 2em 2em;
    }
  }

  .table {
    line-height: 200%;
    background-color: #fff;
    td {
      padding: 1em;
    }

    td:first-child {
      background-color: #885eb2;
      text-align: center;
      color: #fff;
      font-weight: 900;
      font-size: 1.4em;
    }

    td:last-child {
      background-color: #ccc;
      text-align: center;
      width: 140px;
    }
  }

  hr {
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .img-text {
    img {
      max-width: 75%;
      max-height: 300px;
    }

    p {
      width: 75%;
      margin: auto;
      text-align: left;
      line-height: 120%;
      letter-spacing: normal;
      margin-bottom: 3em;
      @media screen and (max-width: 768px) {
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// tibeSpecial2019.vue?cf22d7c6